import { useEffect, useRef, useState } from "react";
import { useThrottledWidthObserver } from "./useThrottledWidthObserver";
/**
 * @returns A `ref` to attach on a div where you want the gradient.
 * The `hasButton` boolean is evaluated to true only when the inner content is too large to be displayed.
 * The `gradientStyle` object must be spread to the same div.
 *
 * **NB** you shoud manually specify a `max-height` attribute on that div.
 *
 * @param nbOfLines limits the contents of a block to the specified number of lines.
 */
export const useGradient = (nbOfLines) => {
    const ref = useRef(null);
    const [hasButton, setHasButton] = useState(true);
    const checkHasButton = () => {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            const shouldcheckHasButton = ref.current.scrollHeight > ref.current.clientHeight;
            setHasButton(shouldcheckHasButton);
        }
    };
    useEffect(() => {
        checkHasButton();
    }, []);
    // @ts-ignore
    useThrottledWidthObserver(ref, checkHasButton);
    const gradientStyle = {
        display: "-webkit-box",
        WebkitLineClamp: nbOfLines,
        WebkitBoxOrient: "vertical",
        whiteSpace: "pre-line",
        overflow: "hidden",
        background: "linear-gradient(to bottom, #323232 50%, white)",
        WebkitTextFillColor: "transparent",
        WebkitBackgroundClip: "text",
    };
    return {
        // @ts-ignore
        ref,
        hasButton,
        gradientStyle,
    };
};
